module.exports = __webpack_public_path__ + "acceptancemark-paymentmethod-1.c3b4c9f0.svg";